import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { userManagement } from "../app/endpoints";
import axiosBaseQueryUserMangement from "./axiosBaseQueryUserMangement";

export const userApi = createApi({
  reducerPath: "userApi",
  baseQuery: axiosBaseQueryUserMangement({
    baseUrl: process.env.REACT_APP_USER_MANAGEMENT_BASE_URL,
  }),
  tagTypes: ["user"],
  endpoints: (builder) => ({
    resetPassword: builder.mutation({
      query(body) {
        return {
          url: userManagement.userController.resetPassword,
          method: "POST",
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),

    forgotPassword: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.userController.forgotPassword}/${body.email}/${body.category}`,
          method: "PUT",
        };
      },
    }),

    findUsername: builder.mutation({
      query: (body) => {
        return {
          url: `${userManagement.userController.findUsername}${body.username}`,
          method: "GET",
        };
      },
    }),
  }),
});

export const {
  useResetPasswordMutation,
  useForgotPasswordMutation,
  useFindUsernameMutation,
} = userApi;
